import React from 'react';
import { Github, Twitter, Mail } from 'lucide-react';

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#f8fafc] dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* About section */}
          <div>
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
              About Tell Us Your Story (TUYS)
            </h3>
            <p className="text-gray-600 dark:text-gray-400">
              Empowering individuals and teams to share their stories and experiences in a meaningful way.
            </p>
          </div>

          {/* Quick links */}
          <div>
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
              Quick Links
            </h3>
            <ul className="space-y-2">
              <li>
                <a href="https://www.techcoffeehouse.com" className="text-gray-600 dark:text-gray-400 hover:text-[#60a3bc] dark:hover:text-[#60a3bc] transition-colors">
                  Tech Coffee House
                </a>
              </li>
              <li>
                <a href="https://notedbytechcoffeehouse.com" className="text-gray-600 dark:text-gray-400 hover:text-[#60a3bc] dark:hover:text-[#60a3bc] transition-colors">
                  Noted by Tech Coffee House
                </a>
              </li>
            </ul>
          </div>

          {/* Social links */}
          <div>
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
              Connect With Us
            </h3>
            <div className="flex space-x-4">
              <a
                href="https://techcoffeehouse.com/contact-apps/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-600 dark:text-gray-400 hover:text-[#60a3bc] dark:hover:text-[#60a3bc] transition-colors"
              >
                <Mail className="w-6 h-6" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-8 pt-8 border-gray-200 dark:border-gray-700">
          <p className="text-center text-gray-600 dark:text-gray-400">
            © {currentYear} Tell Us Your Story. All Rights Reserved
          </p>
        </div>
      </div>
    </footer>
  );
}